enum Variant {
  signUp = 'signUp',
  signIn = 'signIn',
  loggedIn = 'loggedIn',
}

export { Variant };
